import { render, staticRenderFns } from "./DrawForAPrize.vue?vue&type=template&id=07d5d9ea&scoped=true"
import script from "./DrawForAPrize.vue?vue&type=script&lang=js"
export * from "./DrawForAPrize.vue?vue&type=script&lang=js"
import style0 from "./DrawForAPrize.vue?vue&type=style&index=0&id=07d5d9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5d9ea",
  null
  
)

export default component.exports